import Component from '../../../assets/scripts/modules/component';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';


class CopyrightConfirm extends Component {
  init() {
    this.downloadButton = this.element.querySelector('[data-role=download-link]');
    this.checkbox = this.element.querySelector('input[type=checkbox]');

    window.addEventListener('copyright-confirm:start', (event) => {

        this.downloadButton.setAttribute('href', event.detail.href);

        // open lightbox
        fireCustomEvent('lightbox:show', { id: 'copyright-confirm' });

        // show content
        this.show();
    });

    this.checkbox.addEventListener('change', () => {
      if (this.checkbox.checked) {
        this.element.classList.add('is-downloadable');
      }
    });
  }

  show() {
    this.checkbox.checked = false;
    this.element.classList.remove('is-downloadable');
    this.element.classList.add('is-visible');
    setTimeout(() => {
      fireCustomEvent('lightbox:resize');
    }, 100);
  }

  hide() {
    this.element.classList.remove('is-visible');
  }
}

for (const element of document.querySelectorAll('.copyright-confirm')) {
  element.instance = new CopyrightConfirm('copyright-confirm', element, { onLoad: true });
}

for (const element of document.querySelectorAll('[data-permission=permission-required]')) {
  element.addEventListener('click', () => {
    event.preventDefault();
    fireCustomEvent('copyright-confirm:start', {href: element.dataset.target});
  });
}



// WEBPACK FOOTER //
// ./website/components/structures/copyright-confirm/copyright-confirm.js